import { createContext, useState } from "react";

export const CartContext = createContext();

const CartContextProvider = ({ children }) => {
    // El carrito guardado se lee al iniciar (no en un efecto), así el contador ya arranca con
    // el valor correcto y el ícono no "rebota" al abrir la página.
    let [cart, setCart] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("cart")) || [];
        } catch {
            return [];
        }
    });

    // FUNCIÓN CLAVE: Generar ID único con sabor
    const generateItemId = (item) => {
        if (item.saborSeleccionado) {
            return `${item.id}-${item.saborSeleccionado.replace(/\s+/g, '-').toLowerCase()}`;
        }
        return item.id;
    };

    const addItem = (item, quantity) => {
        const calcularPrecioFinal = (item) => {
            if (item.descuento > 0) {
                return Math.round(item.precio - (item.precio * item.descuento) / 100);
            }
            return item.precio;
        };

        const itemId = generateItemId(item);
        const precioFinal = calcularPrecioFinal(item);

        if (isInCart(itemId)) {
            // Sumar cantidad al MISMO producto y MISMO sabor
            let updatedCart = cart.map((prod) => {
                // prod.id ya es el ID único (producto + sabor): no se vuelve a generar
                if (prod.id === itemId) {
                    return { 
                        ...prod, 
                        cantidad: prod.cantidad + quantity,
                        precioFinal: precioFinal
                    };
                }
                return prod;
            });
            setCart(updatedCart);
            localStorage.setItem("cart", JSON.stringify(updatedCart));
        } else {
            // Agregar NUEVO producto o mismo producto con NUEVO sabor
            let updatedCart = [
                ...cart,
                {
                    ...item,
                    id: itemId, // ← Guardar el ID ÚNICO en el item
                    idOriginal: item.id, // ← Guardar también el ID original por si acaso
                    cantidad: quantity,
                    precioFinal: precioFinal,
                    saborSeleccionado: item.saborSeleccionado || null,
                    nombreCompleto: item.saborSeleccionado 
                        ? `${item.nombre} - ${item.saborSeleccionado}`
                        : item.nombre
                },
            ];
            setCart(updatedCart);
            localStorage.setItem("cart", JSON.stringify(updatedCart));
        }
    };

    const removeItem = (id) => {
        const updatedCart = cart.filter((prod) => prod.id !== id);
        setCart(updatedCart);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
    };

    // Cambiar la cantidad de un ítem desde el carrito (mínimo 1; el máximo lo controla el carrito con el stock)
    const updateQuantity = (id, cantidad) => {
        if (!Number.isFinite(cantidad) || cantidad < 1) return;
        const updatedCart = cart.map((prod) => (prod.id === id ? { ...prod, cantidad } : prod));
        setCart(updatedCart);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
    };

    const clear = () => {
        setCart([]);
        localStorage.removeItem("cart");
    };

    const isInCart = (id) => {
        return cart.some((prod) => prod.id === id);
    };

    const cartTotal = () => {
        return cart.reduce((suma, item) => suma + item.cantidad, 0);
    };

    const precioTotal = () => {
        return cart.reduce((suma, item) => {
            return suma + (item.precioFinal * item.cantidad);
        }, 0);
    };

    return (
        <CartContext.Provider
            value={{ 
                cartTotal, 
                precioTotal, 
                cart, 
                addItem, 
                removeItem,
                updateQuantity,
                clear,
                isInCart
            }}
        >
            {children}
        </CartContext.Provider>
    );
};

export default CartContextProvider;